import React from "react";
const Loader = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 1)", 
        zIndex: 9999, 
      }}
    >
      <div className="py-[4rem] flex fixed items-center justify-center">
        <img src="/assets/loader.gif" alt="Loader" width="150" height="150" loading="lazy"/>
      </div>
    </div>
  );
};

export default Loader;
